import ProjectTemplateTaskGroup from "./project-template-task-group";

export default class ProjectTemplate {
  id: number = 0;
  title: string = "";
  taskGroups: ProjectTemplateTaskGroup[] = [];
}
